import { useState } from 'react';
import type { DragEndEvent } from '@dnd-kit/core';
import type { Event } from './useEvents';

export function useDragEvent(
  events: Event[],
  onUpdate: (id: string, data: Partial<Event>) => Promise<any>
) {
  const [isDragging, setIsDragging] = useState(false);

  const handleDragStart = () => {
    setIsDragging(true);
  };

  const handleDragEnd = async (event: DragEndEvent) => {
    setIsDragging(false);
    
    const { active, over } = event;
    if (!over) return;

    const eventId = active.id as string;
    const dropData = over.data.current as { day: Date; hour: number };

    if (!dropData?.day || dropData.hour === undefined) return;

    // Find the original event
    const originalEvent = events.find(e => e.id === eventId);
    if (!originalEvent) return;

    // Calculate new start and end times
    const originalStart = new Date(originalEvent.start_time);
    const originalEnd = new Date(originalEvent.end_time);
    const duration = originalEnd.getTime() - originalStart.getTime();

    const newStart = new Date(dropData.day);
    newStart.setHours(dropData.hour, 0, 0, 0);

    const newEnd = new Date(newStart.getTime() + duration);

    // Update the event
    await onUpdate(eventId, {
      start_time: newStart.toISOString(),
      end_time: newEnd.toISOString(),
    });
  };

  const handleDragCancel = () => {
    setIsDragging(false);
  };

  return {
    isDragging,
    handleDragStart,
    handleDragEnd,
    handleDragCancel,
  };
}
